<template>
    <div class="leveled"><!-- klass detail-->
     

    <div id="componentBoxs" ref="componentBox">
    




      <div class="container bg-white mt-88 relative">

        <div class="row headline-section">
          <div class="col col-1 no-pad"></div>
          <div class="col col-11 no-pad">
            <h2>Detail User Default {{ $route.params }}</h2>
            <p>Voeg een klas toe en selecteer per klas een Praktisch of Theoretisch les programma</p>
          </div>
        </div>

        <div class="nav-side"  v-bind:style="getHeightOfApp">
          <div class="btn inactive"></div>
          <div class="btn next"></div>

        </div>

      </div>







      <div class="container bg-blue padding-bold">
        <div class="row klas-list">
          <div class="col col-1 no-pad"></div>
          <div class="col col-11 no-pad">yyyy
            
          

          </div>
        </div>

        <div class="row klas-list">
          <div class="col col-1 no-pad"></div>
          <div class="col col-11 no-pad">kkkk







             



          </div>
        </div>

      </div>


      <div class="container bg-light-blue">
        <div class="row klas-list input-part">
          <div class="col col-1 no-pad"></div>
          <div class="col col-11 no-pad">
            <h4><span>+</span> Voeg een klas toe:</h4>

            



          </div>
        </div>
      </div>



























    </div>

        
    </div>
</template>

























<script>

 


   export default {
        name: 'Pageklass',

    

    data: function () {
        return {
          getHeightOfApp: { },
          //parentIDVar: localStorage.getItem("parentID"),
          authorIdVue: localStorage.getItem("userID"),
          //hostname: window.location.origin,
            hostname: 'http://page19.test',
            

            
        }
    },


    mounted () {
      this.matchHeight();
      
    },
    

    
    methods: {
      matchHeight () {
          
          var heightString = $('#componentBox').height();
          $('.nav-side').height(heightString);  
        },

        redirectToClass(){
          var self = this;
          $.ajax({        
                url: this.hostname+"/wp/wp-json/wp/v2/classes",
                dataType: "text",
                success: function(data2) {
                    var json2 = $.parseJSON(data2);                            
                    for (var j=0;j<1;++j){ 
                                                
                      if (self.authorIdVue == json2[j].author) {

                       if (j==0) {
                        console.log("redirect it to first class = ");
                          console.log(json2[0].title);
                          //self.$router.replace({ id: json2[j].id });
                          //self.$router.push('/tijdslijn/'+json2[0].id);
                        }

                      }
                    }
                  }
                });
        }

    }//end methods





}


        
    








</script>